import { SECOND_CLOSE_DATE } from './utils/Constants'
import { useRootContext } from './contexts/RootContext'
import { useLocation, useNavigate } from 'react-router-dom'
import { formatDuration, intervalToDuration } from 'date-fns'
import React, { useEffect, useState } from 'react'

const hiddenPrefixes = ['/create']

const shouldShowOnPath = (pathname) => !hiddenPrefixes.some(prefix => pathname.startsWith(prefix))

const buildCountdown = (endDate) => {
  const end = new Date(endDate)
  const now = new Date()

  if (now >= end) return 'less than a minute'

  return formatDuration(intervalToDuration({ start: now, end }), { delimiter: ', ' }) || 'less than a minute'
}

export default function SecondChanceBanner() {
  const location = useLocation()
  const navigate = useNavigate()
  const { secondChanceAvailable } = useRootContext()
  const [countdown, setCountdown] = useState(() => buildCountdown(SECOND_CLOSE_DATE.computer))

  useEffect(() => {
    if (!secondChanceAvailable) return undefined

    const interval = setInterval(() => {
      setCountdown(buildCountdown(SECOND_CLOSE_DATE.computer))
    }, 1000)

    return () => clearInterval(interval)
  }, [secondChanceAvailable])

  if (!secondChanceAvailable || !shouldShowOnPath(location.pathname)) return null

  return (
    <div className="second-chance-banner" role="region" aria-label="Second chance brackets are open">
      <div className="second-chance-banner-content">
        <p>
          <strong>Round of 32 is set!</strong> Create a second chance bracket now. Knockout stage begins in {countdown}.
        </p>
        <div className="second-chance-banner-actions">
          <button className="second-chance-banner-link" type="button" onClick={() => navigate('/create')}>
            Create bracket
          </button>
        </div>
      </div>
    </div>
  )
}
